import { State } from '..';

interface EventProps {}

interface Config<S, P, A, R> {
  nextState: number;
  attributes?: Partial<A>;
}

const StateAnyAction = function <S, P extends EventProps, A extends {}, R>({
  nextState,
  attributes = {},
}: Config<S, P, A, R>): State<S, P, A, R> {
  return {
    onAction: async () => {
      return {
        type: 'MOVE',
        data: {} as any,
        nextState,
      };
    },
    attributes: {
      ...(attributes as any),
    },

    nodeName: 'T.states.anyAction',
    outputs: [
      {
        name: 'onAction',
        to: nextState,
      },
    ],
  };
};

export default StateAnyAction;
